export enum ContractorPortalStep {
  ContractorApplication = 'ContractorApplication',
  Congratulations = 'Congratulations',
  AlreadySetUpWithCSM = 'AlreadySetUpWithCSM',
  AlreadySetUpWithoutCSM = 'AlreadySetUpWithoutCSM',
  NotFoundContact = 'NotFoundContact',
}
